module.exports = __webpack_public_path__ + "img/elegant.9a168968.jpg";